<template>
    <section class="ds-urv-employee-group">
        <h2 class="ds-urv-section-title">{{ title }}</h2>
        <ul class="ds-urv-employee-list">
            <li v-for="employee in employees" :key="employee.user_id" class="ds-urv-employee-item">
                <avatar
                    :first-name="getNameParts(employee.name).firstName"
                    :last-name="getNameParts(employee.name).lastName"
                    :url="employee.avatar"
                    size="sm"
                    width="40"
                    height="40"
                />
                <span class="ds-urv-employee-name">{{ employee.name }}</span>
                <span
                    class="ds-urv-employee-status"
                    :style="{ backgroundColor: getStatusColor(employee.status) }"
                    :aria-label="getStatusLabel(employee.status)"
                    :title="getStatusLabel(employee.status)"
                ></span>
            </li>
        </ul>
    </section>
</template>

<script setup lang="ts">
import type { UrvWorker } from '@/api/urv'

defineProps<{
    title: string
    employees: UrvWorker[]
}>()

function getNameParts(name: string) {
    const [lastName, firstName] = name.trim().split(/\s+/, 2)
    const fallbackName = lastName || firstName || '—'

    return {
        firstName: firstName || fallbackName,
        lastName: lastName || fallbackName,
    }
}

function getStatusLabel(status: UrvWorker['status']) {
    const labels: Record<UrvWorker['status'], string> = {
        working: 'На рабочем месте',
        late: 'Опаздывает',
        error: 'Ошибка отметки',
        absent: 'Отсутствует',
        shift_today: 'Ожидается на смене',
    }

    return labels[status]
}

function getStatusColor(status: UrvWorker['status']) {
    if (status === 'working') return 'var(--color-success)'
    if (status === 'late') return 'var(--color-warning)'
    if (status === 'error') return 'var(--color-danger)'
    if (status === 'absent') return 'var(--color-moderate)'
    if (status === 'shift_today') return 'var(--color-text-placeholder)'

    return 'var(--color-text-placeholder)'
}
</script>
